class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      // this.scrollIntoView({ behavior: 'smooth' });
      return
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);


document.addEventListener('DOMContentLoaded', function() {
  const input = document.querySelector('#Search-In-Template');
  const grid = document.querySelector(".on-search-result-card");
  const mainDiv = document.querySelector('.mainDivhideShow');
  const list = document.querySelector('#autocomplete-list');
  const form = document.querySelector('.search');
  const btn  = document.querySelector(".search__button.field__button");
  const clearBtn = document.querySelector('#clear-search');

  if (!input || !list || !mainDiv || !btn || !clearBtn) return;

  mainDiv.style.display = 'none';




    /* ===============================
        Autocomplete Suggestion Fetch
    =============================== */
    input.addEventListener('input', function() {
      const query = this.value.trim();

      if (query.length < 2) {
        mainDiv.style.display = 'none'; 
        return;
    }

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            lastSuggestions = products;

            if (!products.length) {
              mainDiv.style.display = 'none';
              return;
            }

            list.innerHTML = products
              .map(product => `
                <li data-url="${product.url}" data-title="${product.title}">
                  <a href="${product.url}">${product.title}</a>
                </li>
              `)
              .join('');

            mainDiv.style.display = 'block';
          });
    });

    btn.addEventListener("click", function (e) {
      e.preventDefault(); // stop Shopify default form behavior

      const query = input.value.trim();
      if (!query) return;

      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last`;
    });
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const query = input.value.trim();
      if (!query) return;

      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last`;
    });

    input.addEventListener('input', function () {
      if (this.value.trim().length > 0) {
        clearBtn.style.display = "block";
      } else {
        clearBtn.style.display = "none";
      }
    });

    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = `/search`;
    });

    function triggerSearch() {
      const query = input.value.trim();
      if (!query) return;

      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last`;
    }
    
    input.addEventListener("keyup", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        triggerSearch();
      }
    })

    /* ===============================
        Hide list when clicking outside
    =============================== */
    document.addEventListener('click', (e) => {
      if (!mainDiv.contains(e.target) && e.target !== input) {
        mainDiv.style.display = 'none';
      }
    });

   
    input.addEventListener('focus', function() {
      if (this.value.trim().length < 2) {
        mainDiv.style.display = 'none'; // fix: no list until typing
      }
    });
});




// document.addEventListener("DOMContentLoaded", function () {

//   function updateRebuySplideDots() {
//     const dotsUl = document.querySelector(".rebuy-product-grid ul");

//     if (!dotsUl) return false;

//     const dots = dotsUl.querySelectorAll("li");
//     if (dots.length === 0) return false;

//     const dotWidth = (100 / dots.length) + "%";

//     dots.forEach((dot) => {
//       dot.style.width = dotWidth;
//       dot.style.flex = "0 0 " + dotWidth;
//     });

//     return true;
//   }

//   // --- 1️⃣ Retry System (Ensures slider loads first) ---
//   let tries = 0;
//   let maxTries = 20; // tries for ~4 seconds

//   function retryDots() {
//     if (updateRebuySplideDots()) {
//       return; // success
//     }
//     tries++;
//     if (tries < maxTries) {
//       setTimeout(retryDots, 200);
//     }
//   }
//   retryDots();


//   // --- 2️⃣ MutationObserver (Detect when Rebuy injects slider) ---
//   const observer = new MutationObserver(() => {
//     updateRebuySplideDots();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });

//   // --- 3️⃣ Rebuy JS Event Listener (if Rebuy fires events) ---
//   document.addEventListener("rebuy:cart.show", updateRebuySplideDots);
//   document.addEventListener("rebuy:cart.ready", updateRebuySplideDots);
//   document.addEventListener("rebuy:page.load", updateRebuySplideDots);
//   document.addEventListener("rebuy:products.loaded", updateRebuySplideDots);
// });

const popularListSerch = document.getElementById("popular-list-searches"); // replace with your div's ID

// Get current URL query parameters
const urlParams = new URLSearchParams(window.location.search);

// Check if both 'q' and 'type' exist, and type is 'product'
if (urlParams.has("q") && urlParams.get("type") === "product") {
  // Hide the div
  popularListSerch.style.display = "none";
} else {
  // Show the div
  popularListSerch.style.display = "block";
}